export interface MenuItem {
  code: string;
  name: string;
  link: string;
  permissionsRequired: any[];
  submenu: MenuItem[] | null;
}
